/** @typedef {import('@/features/documentPreview/documentPreviewTypes.js').ArtifactKind} ArtifactKind */

import {
  CREATE_APP_RE,
  CREATE_DOC_RE,
  CREATE_SPREADSHEET_RE,
  normalizeGeneratedArtifactPrompt,
} from './generatedArtifactAssistantPayloadPatterns.js'

export { normalizeGeneratedArtifactPrompt }
export { resolveGeneratedArtifactDetails } from './generatedArtifactAssistantPayloadResolve.js'

/**
 * @param {string} trimmed
 * @returns {ArtifactKind | null}
 */
export function detectGeneratedArtifactKind(trimmed) {
  const normalized = normalizeGeneratedArtifactPrompt(trimmed)
  if (CREATE_DOC_RE.test(normalized)) return 'doc'
  if (CREATE_SPREADSHEET_RE.test(normalized)) return 'spreadsheet'
  if (CREATE_APP_RE.test(normalized)) return 'html'
  return null
}

/** @param {string} trimmed */
export function isGeneratedArtifactUserMessage(trimmed) {
  return detectGeneratedArtifactKind(trimmed) != null
}
